<template>
  <upload-content v-bind="uploadContentProps">
    <slot></slot>
  </upload-content>
  {{ uploadFiles }}
</template>

<script setup lang="ts">
import UploadContent from './upload-content.vue'
import { UploadFile, UploadFiles, uploadProps, UploadRawFile } from './upload'
import { computed, ref, watch } from 'vue'
import { UploadContentProps } from './upload-content'

defineOptions({
  name: 'cms-upload'
})

const props = defineProps(uploadProps)
const emit = defineEmits({})

const uploadFiles = ref<UploadFiles>(props.FileList)

watch(() => uploadFiles, (newVal) => {
  emit('onUpdate:file-list', newVal)
})
const findFile = (rawFile: UploadRawFile) => {
  return uploadFiles.value.find(file => file.uid === rawFile.uid)
}

const uploadContentProps = computed<UploadContentProps>(() => ({
  ...props,
  onStart: rawFile => {
    console.log('onStart')
    const uploadFile: UploadFile = {
      uid: rawFile.uid,
      name: rawFile.name,
      percentage: 0,
      raw: rawFile,
      size: rawFile.size,
      status: 'start'
    }
    // 这个字段可以实现预览
    uploadFile.url = URL.createObjectURL(rawFile)
    uploadFiles.value = [...uploadFiles.value, uploadFile]
    props.onChange(uploadFile)
  },
  onProgress: (e, rawFile) => {
    console.log('onProgress')
    const uploadFile = findFile(rawFile)!
    uploadFile.status = 'uploading'
    uploadFile.percentage = e.pecetange
    props.onProgress(e, uploadFile, uploadFiles.value)
  },
  onRemove: async rawFile => {
    const uploadFile = findFile(rawFile)!
    const r = await props.beforeRemove(uploadFile, uploadFiles.value)
    if (r != false) {
      const fileList = uploadFiles.value
      fileList.splice(fileList.indexOf(uploadFile), 1)
      props.onRemove(uploadFile, fileList)
    }
  },
  onError: (err, rawFile) => {
    const uploadFile = findFile(rawFile)!
    uploadFile.status = 'error'
    const fileList = uploadFiles.value
    fileList.splice(fileList.indexOf(uploadFile), 1)
    props.onError(err, uploadFile, fileList)
    console.log('onError')
  },
  onSuccess: (res, rawFile) => {
    const uploadFile = findFile(rawFile)!
    uploadFile.status = 'success'
    const fileList = uploadFiles.value
    props.onSuccess(res, uploadFile, fileList)
    console.log('onSuccess')
  }
}))
</script>

<style scoped></style>
